class SMErrorHelper {
  static hasEmptyRequiredFields(resource, fields) {
    return fields.some((field) => {
      return !resource[field] || 
             resource[field] == null || 
             (Array.isArray(resource[field]) && resource[field].length == 0);
    });
  }

  static hasEmptyNotZeroRequiredFields(resource, fields) {
    return fields.some((field) => {
      return resource[field] != 0 && (!resource[field] ||
        resource[field] == null ||
        (Array.isArray(resource[field]) && resource[field].length == 0));
    });
  }

  static hasValidationErrorFields(errors, resourceName, fields) {
    return fields.some((field) => {
      return errors.some((error) => {
        return error.resource == resourceName && error.field == field;
      });
    });
  }
}
export default SMErrorHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMErrorHelper.js